import { AppCopyIcon } from 'shared/UI/UIKit/icons/Copy';
import { AppFlex } from 'shared/UI/UIKit/Flex';
import { AppDeleteIcon } from 'shared/UI/UIKit/icons/Delete';
import type { Curriculum, CurriculumSource } from 'services/api';
import type { AppTableColumn } from 'shared/UI/UIKit/Table';
import styles from '../ui/styles.module.scss';

type GetColumnsProps = {
  onCopy: (curriculumId: number) => void;
  onDelete: (curriculumId: number) => void;
};

export const getColumns = ({ onCopy, onDelete }: GetColumnsProps): AppTableColumn<Curriculum>[] => {
  return [
    {
      key: 'id',
      title: 'ID',
      dataIndex: ['id'],
    },
    {
      key: 'name',
      title: 'Название',
      dataIndex: ['name'],
    },
    {
      key: 'source',
      title: 'Создано пользователем',
      dataIndex: ['source'],
      render: (source: CurriculumSource) => {
        return source === 'USER_CREATED' ? 'Да' : 'Нет';
      },
    },
    {
      key: 'controls',
      title: '',
      dataIndex: [],
      maxWidth: '6rem',
      render: (_: unknown, record: Curriculum) => {
        return (
          <AppFlex direction="row" alignItems="center">
            <AppCopyIcon
              className={styles.icon}
              onClick={(e) => {
                e.stopPropagation();
                if (record.id != null) {
                  onCopy(record.id);
                }
              }}
            />
            {record.source === 'USER_CREATED' && (
              <AppDeleteIcon
                className={styles.icon}
                onClick={(e) => {
                  e.stopPropagation();
                  if (record.id != null) {
                    onDelete(record.id);
                  }
                }}
              />
            )}
          </AppFlex>
        );
      },
    },
  ];
};
